import { withInstall } from '@lit-element/utils'

import Text from './src/text.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtText: SFCWithInstall<typeof Text> = withInstall(Text)
export default LtText

export * from './src/text'
